export default __webpack_public_path__ + "static/media/grid.56014b82.svg";